/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';

import PhilAvatar from '../Phil/PhilAvatar';
import { avatarSizePropTypes, AVATAR_MEDIUM } from '../Phil/avatarSizes';

import './PhilHeader.less';

export function PhilHeader({ children, headerText, subheaderText, size }) {
  return (
    <header className="PhilHeader">
      <PhilAvatar size={size} />
      <h1 className="phil_step_header">{headerText}</h1>
      <p className="phil_step_subhead">
        {subheaderText}
      </p>
      <div className="phil_header_content">
        {children}
      </div>
    </header>
  );
}

PhilHeader.propTypes = {
  subheaderText: PropTypes.string,
  headerText: PropTypes.string,
  size: avatarSizePropTypes,
  children: PropTypes.node,
};

PhilHeader.defaultProps = {
  subheaderText: PropTypes.string,
  headerText: PropTypes.string,
  size: AVATAR_MEDIUM,
  children: null,
};
